module.exports = {"PATH":"results","COMPANY":{"ID":"id","NAME":"name","SHIPPING_COMPANY":"shipping_company","IS_ACTIVE":"is_active"}}


//////////////////
// WEBPACK FOOTER
// ./src/plugins/tfs/platformConfigs/integrationMaps/cargoCompanies.json
// module id = 1763
// module chunks = 1